import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en/translation.json';
import translationRU from './locales/ru/translation.json';
import translationKK from './locales/kk/translation.json';

export const SUPPORTED_LANGUAGES = ['kk', 'ru', 'en'];

// Ключ в localStorage. РАНЬШЕ ЗДЕСЬ БЫЛ РАЗНОБОЙ: переключатель языков писал
// в "selectedLanguage", а инициализация читала "selectedFlag" — то есть выбор
// языка не переживал перезагрузку. Сайт открывался на английском и только
// потом, когда домонтируется футер, перескакивал на нужный язык.
// Теперь ключ один и живёт здесь.
export const LANGUAGE_STORAGE_KEY = 'selectedLanguage';

const readStoredLanguage = () => {
    try {
        const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
        return SUPPORTED_LANGUAGES.includes(stored) ? stored : null;
    } catch {
        // приватный режим в Safari: localStorage может кидать исключение
        return null;
    }
};

// Язык браузера («ru-RU» → «ru»), если человек ещё ничего не выбирал.
const detectLanguage = () => {
    const browser = (navigator.language || '').split('-')[0];
    return SUPPORTED_LANGUAGES.includes(browser) ? browser : 'en';
};

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: translationEN },
            ru: { translation: translationRU },
            kk: { translation: translationKK },
        },
        lng: readStoredLanguage() || detectLanguage(),
        fallbackLng: 'en',
        supportedLngs: SUPPORTED_LANGUAGES,
        interpolation: {
            escapeValue: false,
        },
    });

// <html lang> должен совпадать с языком страницы. От него зависят: озвучка в
// скринридере, переносы по слогам, правила :lang() в src/index.css и то,
// как страницу индексирует поиск.
const syncDocumentLanguage = (lng) => {
    document.documentElement.setAttribute('lang', lng);
};

syncDocumentLanguage(i18n.language);
i18n.on('languageChanged', syncDocumentLanguage);

export const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    try {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
    } catch {
        // не смогли запомнить — не повод падать
    }
};

export default i18n;
